import { useEffect } from 'react';
import { useModelStore } from '../store/modelStore';
import ModelCard from '../components/ModelCard';

export default function LibraryPage() {
  const { models, setModels, isLoading, setLoading } = useModelStore();

  useEffect(() => {
    setLoading(true);
    import('../lib/api').then((m) => m.apiFetch('/api/models'))
      .then((res) => res.json())
      .then((data) => {
        const payload = data as { models?: import('../types').Model[] };
        setModels(payload.models ?? []);
      })
      .catch(() => setModels([]))
      .finally(() => setLoading(false));
  }, [setModels, setLoading]);

  return (
    <div className="container" style={{ paddingTop: '1.5rem' }}>
      <h2 style={{ marginBottom: '1rem' }}>My Library</h2>
      {isLoading ? (
        <p style={{ color: 'var(--muted)' }}>Loading...</p>
      ) : models.length === 0 ? (
        <p style={{ color: 'var(--muted)' }}>No models yet. Upload or generate one.</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
          {models.map((model) => (
            <ModelCard key={model.id} model={model} />
          ))}
        </div>
      )}
    </div>
  );
}
